import { useMutation } from '@tanstack/react-query';

import { fetcher } from 'shared/utils/fetcher';
import { useStoreValue } from 'state/hooks/useStore';
import type { AuthenticateRequest, AuthenticateResponse } from 'api/members/authenticate';
import { EnhancedError } from 'shared/utils/errors';

import { MONITORING_TAGS } from 'constants/monitoring';
import { Session } from './schema';
import { useSession } from './useSession';

export const useAuthenticate = () => {
  const store = useStoreValue();
  const [, setSession] = useSession();

  return useMutation({
    mutationFn: async (options: Omit<AuthenticateRequest, 'store'>): Promise<Session> => {
      try {
        const { data } = await fetcher.post<AuthenticateResponse>('/api/members/authenticate', {
          store,
          ...options
        });

        setSession(data);

        return data;
      } catch (error) {
        throw new EnhancedError({
          cause: error,
          tags: {
            [MONITORING_TAGS.AUTH]: true
          }
        });
      }
    }
  });
};
